import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ContentdataService } from 'src/app/services/contentdata.service';
import { ViewSingleReportComponent } from '../view-single-report/view-single-report.component';

@Component({
  selector: 'app-all-reports',
  templateUrl: './all-reports.component.html',
  styleUrls: ['./all-reports.component.css']
})
export class AllReportsComponent implements OnInit {
  allReports = [];

  p: number = 1;
  filteredStatus = '';
  totalCount: number;

  constructor(
    public matDialog: MatDialog,
    private contentDataService: ContentdataService,
    private spinner: NgxSpinnerService,
    private toast: ToastrService
  ) {}

  ngOnInit(): void {
    this.getAllReports(0);
  }

  getAllReports(skip) {
    this.spinner.show();
    let payload = {
      skip,
      limit: 10
    }

    this.contentDataService
      .getAllReports(payload)
      .subscribe((res) => {
        this.allReports = res['bugData'];
        this.totalCount = res['bugTotal']
        this.spinner.hide();
      });
  }

  onPageChange(e) {
    this.p = e;
    let skip = e == 1 ? 0 : (e - 1) * 10;
    this.getAllReports(skip)
  }

  viewSingleReport(reportData: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.id = 'view-single-report-component';
    dialogConfig.height = '400px';
    dialogConfig.width = '460px';
    //passing data
    dialogConfig.data = { reportData: reportData };

    const modalDialog = this.matDialog.open(
      ViewSingleReportComponent,
      dialogConfig
    );
  }

}
